module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/years/years-show/years-show.component.scss
// module id = ./src/app/views/setting/years/years-show/years-show.component.scss
// module chunks = main